<title matDialogTitle>Klart!</title>
<div matDialogContent>
  <p>Vi har skapat ett dokument. Du kan nu välja att förhandsgranska eller att
    skicka för signering. </p>
  <p style="padding: 1px">Dokument för förhandsgranskning öppnas i ett nytt fönster.</p>
</div>
<mat-dialog-actions>
  <button [matDialogClose]="{status: 'cancel',  documentId: data.documentId}"
          matButton="outlined"
  >Avbryt
  </button>
  <button (click)="preview()" matButton="outlined">Förhandsgranska</button>
  <button [matDialogClose]="{status: 'sign', documentId: data.documentId}"
          matButton="filled"
  >Skicka för signering
  </button>
</mat-dialog-actions>
